module.exports = __webpack_public_path__ + "img/logo.e18672f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo.jpg
// module id = JC9h
// module chunks = 3